import { useLingui } from '@lingui/react';
//import { useEffect, useState } from 'react';
//import { styled } from 'styled-components';

export function Loading() {
  const { i18n } = useLingui();

  return <p>{i18n._('common.loading')} ...</p>;
}
